import * as React from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  ImageListItemBar,
  Typography,
} from "@mui/material";
import GenerateThumbnail from "./GenerateThumbnail";
import Packshot from "./Packshot";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";
import { CustomToolTip } from "./components/CustomToolTip";

export default function PackShotThumbnailData(props) {
  const copyText = (name) => {
    navigator.clipboard.writeText(name);
  };
  return (
    <>
      <div
        style={{
          width:"100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
          gap: "1rem",
          position: "relative",
          
          // overflowX:"scroll"
        }}
      >
        <Card
          sx={{
            cursor: "default",
            flex: "1",
            width: "50%",
            boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;",
            backgroundColor: "transparent",
            // overflowX:"scroll"
          }}
        >
          <CardActionArea
            sx={{
              pointerEvents: "none",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Packshot image={props.predictions.packshot}  />
            <CardContent>
              <Typography
                gutterBottom
                variant="body2"
                component="span"
                style={{ fontSize: "10px",fontFamily: "ChalkboardSE-Regular"}}
              >
                packshot
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
        <Card
          sx={{
            cursor: "default",
            flex: "1",
            width: "50%",
            boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;",
            backgroundColor: "transparent",
            // overflowX:"scroll"
          }}
        >
          <CardActionArea
            sx={{
              pointerEvents: "none",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <GenerateThumbnail data={props} />
            <CardContent>
              <Typography
                gutterBottom
                variant="body2"
                component="span"
                style={{ fontSize: "10px",fontFamily: "ChalkboardSE-Regular" }}
              >
                thumbnail
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
        <CustomToolTip
          title={props.predictions.skus}
          placement="top"
          // classes={{ tooltip: classes.customTooltip }}
          // sx={{ maxWidth: "10vw" }}
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                width: "14vw",
                "@media screen and (max-height: 700px)": {
                  fontSize: "10px",
                },
                "@media screen and (max-height: 600px)": {
                 
                  fontSize: "10px",
                },
              },
            },
          }}
        >
          <ImageListItemBar
            title={
              <span
                style={{
                  fontSize: "12px",
                  color: "rgba(73 , 148, 236, 0.875)",
                  // fontWeight: "600",
                  backgroundColor: "#d7f3ff",
                  fontFamily: "ChalkboardSE-Regular",
                  wisth:"90%",
                  
                }}
              >
                {props.predictions.skus}
              </span>
            }
            sx={{
              "& .MuiImageListItemBar-title": {
                color: "rgba(73 , 148, 236, 0.875)",
              },
            }}
            style={{
              fontSize: "12px",
              height: "1.5rem",
              margin: "auto",
              position: "absolute",
              bottom: "-10px",
              width:"100%",
              backgroundColor: "#d7f3ff",
              color: "74adf0",
            }}
            actionIcon={
              <IconButton
                sx={{ color: "#74adf0", height: "0.8rem" }}
                aria-label={`info about ${props.predictions.skus}`}
                onClick={() => copyText(props.predictions.skus)}
              >
                <ContentCopyIcon
                  style={{ fontSize: "15px", color: "74adf0" }}
                 
                />
              </IconButton>
            }
          />
        </CustomToolTip>
      </div>
    </>
  );
}
